import React, { useContext, useEffect, useState } from 'react';
import CardContainer from 'components/redesign/CardContainer';
import { KpiData } from 'components/redesign/KpiTile/types';
import KpiGrid from 'components/redesign/KpiGrid';
import KpiDefinitionData from 'service/KpiDefinitionData';
import { FilterContext } from 'components/FilterBar/FilterProvider';
import KpiTile from 'components/redesign/KpiTile';
import { useDynamicGraphQLQuery } from 'hooks/useDynamicGraphQLQuery';
import avgUserInteractions from 'v2/kpis/mfg/mes-lite/user-interaction/avgUserInteractions';
import interactionRatioByUser from 'v2/kpis/mfg/mes-lite/user-interaction/interactionRatioByUser';
import wasteEvents from 'v2/kpis/mfg/mes-lite/user-interaction/wasteEvents';
import throughputEvents from 'v2/kpis/mfg/mes-lite/user-interaction/throughputEvents';
import downtimeFaultsAdoption from 'v2/kpis/mfg/mes-lite/user-interaction/downtimeFaultsAdoption';
import { constants } from 'constants/Constants';

interface UserInteractionSummaryProps {
  title?: string;
}

const UserInteractionSummary: React.FC<UserInteractionSummaryProps> = ({
  title = 'Summary',
}) => {
  const [overViewConfig, setOverViewConfig] = useState<KpiData[]>([]);
  const { selectedProduct, selectedPlant, selectedFrequency } =
    useContext(FilterContext);

  // Create custom filters with conditional weekly toggle logic
  const createCustomFilters = () => {
    const baseFilters = {
      siteId: selectedPlant?.id ? selectedPlant?.id : null,
    };

    // Conditionally append weekly toggle filters
    if (
      selectedFrequency?.id === 'Weekly' &&
      selectedProduct?.productId === constants?.products?.MesLite
    ) {
      return {
        ...baseFilters,
        period: 28,
      };
    }

    return baseFilters;
  };

  const customFilters = createCustomFilters();

  const { data, isLoading } = useDynamicGraphQLQuery(
    'getMesUserInteractionScorecard',
    customFilters
  );

  const generateScoreCardItems = (data: any) => {
    return [
      avgUserInteractions.handler(data),
      interactionRatioByUser.handler(data),
      wasteEvents.handler(data),
      throughputEvents.handler(data),
      downtimeFaultsAdoption.handler(data),
    ];
  };

  useEffect(() => {
    if (data?.getMesUserInteractionScorecard?.data) {
      setOverViewConfig(
        generateScoreCardItems(data.getMesUserInteractionScorecard.data)
      );
    }
  }, [data]);

  return (
    <CardContainer
      isLoading={isLoading}
      title={title}
      showInfoIcon={true}
      dataDefinitions={{
        sections:
          KpiDefinitionData[selectedProduct?.productId]
            ?.userBehaviorAndEngagement?.userInteractionScoreCard ?? [],
      }}
      isAccordion={false}
    >
      <KpiGrid
        columnsDesktop={5}
        columnsTablet={2}
        columnsMobile={2}
        showHDividerMobile={false}
      >
        {overViewConfig.map((item, index) => (
          <KpiTile key={index} data={item} />
        ))}
      </KpiGrid>
    </CardContainer>
  );
};

export default UserInteractionSummary;
